var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96094 14.875C4.57135 14.875 4.23797 14.7364 3.96077 14.4592C3.68358 14.182 3.54474 13.8484 3.54427 13.4583V4.25H2.83594V2.83333H6.3776V2.125H10.6276V2.83333H14.1693V4.25H13.4609V13.4583C13.4609 13.8479 13.3223 14.1815 13.0451 14.4592C12.768 14.7369 12.4343 14.8755 12.0443 14.875H4.96094ZM12.0443 4.25H4.96094V13.4583H12.0443V4.25ZM6.3776 12.0417H7.79427V5.66667H6.3776V12.0417ZM9.21094 12.0417H10.6276V5.66667H9.21094V12.0417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.dcf0e7bac669aa6d40a2ddfba8299347.svg";
export { ForwardRef as ReactComponent };